import styled, {keyframes} from "styled-components";
import React, {Component} from "react";
import ModilectWordmark from "../Images/ModilectWM.svg";
import ModilectWordmarkW from "../Images/ModilectWMW.svg";
import longArrowImg from "../Images/longArrow.svg";
import {Plus} from "react-feather";
import policyPdf from "../Legal/ModilectIntegritetspolicy.pdf";
import IconModilect from "../Images/icon.svg"
export {IconModilect};

export const Policy = policyPdf;
export const mediaMax = "max-width: 800px";
export const mediaMaxOld = "max-width: 340px";
export const mediaMaxPhone = "max-width: 500px";

export const background = "rgb(76,76,76)";

export const primary = "#FFD184";
export const grayText = "#31312C";

export const dark = "#292929";
export const lightdark = "#555";
export const light = "#bbb";
export const lighter = "#ddd";
export const lightest = "#F7F7F7";
export const gray = "#9B9B9B";
export const green = "#78EC71";
export const red = "#FF7586";
export const yellow = "#FFE400";

export const shadow = "0px 0px 150px -5px rgba(0,0,0,0.2)";
export const shadowHover = "0px 0px 180px -5px rgba(0,0,0,0.5)";
export const shadowSmall = "0px 0px 15px 1px rgba(0,0,0,0.23)";
export const sRadius = "5px";
export const bRadius = "15px";

export const bounce = "cubic-bezier(0.67, 2.13, 0.5, 0.49)";
export const spring = "cubic-bezier(0.32,-0.33, 0, 0.63)";

export const StandardPadding = "10%";

export const containerWidth = "1100px";
export const SafeContainWidth = "max-width:1120px";

export const Contain = styled.div `
  width: 100%;
  transition: 0.8s ease;
  box-sizing: border-box;
  padding: 0;
  max-width: ${containerWidth};
  margin: 0 auto;
`;

export const ContainWPadding = Contain.extend `
  @media screen and (${SafeContainWidth}) {
    width: 85%;
  }
`;

export const Margin = styled.div `
  height: 100px;
`;
export const SmallMargin = styled.div `
  height: 20px;
`;

export const PrimarySpan = styled.span `
  color: ${primary};
`;

export const Line = styled.div `
  background: ${dark};
  height: 1px;
  width: 100%;
`;

export const LineVertical = styled.div `
  background: ${dark};
  width: 5px;
  height: 100%;
`;

export const ThinLine = styled.div `
  background: ${lighter};
  height: 1px;
  width: 100%;
`;
export const Separator = styled.div `
  height: 2px;
  width: 90%;
  max-width: 400px;
  min-width: 50px;
  margin: 0 auto;
`;
export const SmallSeparator = styled.div `
  background: ${light};
  height: 2px;
  width: 30%;
  max-width: 120px;
  min-width: 40px;
  margin: 0 auto;
`;

// Animations

export const spinner = keyframes ` 
    from {transform: rotate(0deg);}
    to {transform: rotate(360deg);}
    `;
export const shakeAnim = keyframes ` 
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  {
    transform: translate3d(-5px, 0, 0);
  }
  
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
 {
    transform: translate3d(10px, 0, 0);
  }

  60%,
  80% {
    transform: translate3d(5px, 0, 0);
  }
    `;

// Components

export const HideOnMobile = styled.div `
  display: block;

  @media screen and (${mediaMaxPhone}) {
    display: none;
  }
`;
export const ShowOnMobile = styled.div `
  display: none;

  @media screen and (${mediaMaxPhone}) {
    display: block;
  }
`;

export const AttentionTitle = styled.h2 `
  text-transform: uppercase;
  letter-spacing: 5px;
  font-size: 7vw;
  font-weight: 500;
  line-height: 8vw;
  margin: 0;
  @media screen and (min-width: 1200px) {
    font-size: 80px;
    line-height: 80px;
  }
  @media screen and (${mediaMaxPhone}) {
    font-size: 5.5vw;
    font-weight: 600;
  }
`;

export const SplashTitle = styled.h1 `
  hyphens: auto;
  text-transform: uppercase;
  letter-spacing: 10px;
  font-size: 5.5vw;
  font-weight: 500;
  line-height: 8vw;
  margin: 0;

  @media screen and (max-width: 630px) {
    display: ${props => (props.removeMobile
  ? "none"
  : "block")};
  }
  @media screen and (min-width: 1200px) {
    font-size: 70px;
    line-height: 80px;
  }
`;

export const SplashTitleMobile = styled.h1 `
  font-size: 5.5vw;
  display: none;
  margin: 0;
  font-weight: 500;
  line-height: 40px;
  hyphens: auto;
  text-transform: uppercase;
  letter-spacing: 10px;
  @media screen and (max-width: 630px) {
    display: block;
  }
`;

export const HugeTitle = styled.h2 `
  font-size: 80px;
  font-weight: 500;
  margin: 0;
`;

export const LargeTitle = styled.h2 `
  text-transform: uppercase;
  letter-spacing: 5px;
  font-size: 37px;
  font-weight: 300;
  margin: 0;
  @media screen and (max-width: 530px) {
    font-size: 32px;
  }
  @media screen and (${mediaMaxPhone}) {
    font-size: 28px;
  }
`;

export const MediumTitle = styled.h2 `
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  @media screen and (max-width: 530px) {
    font-size: 18px;
  }
`;
export const SpreadTitle = styled.h2 `
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 200;
  letter-spacing: 25px;
  margin: 0;
`;
export const SmallTitle = styled.h3 `
  font-size: 15px;
  font-weight: 500;
  margin: 0;
`;
export const InfoParagraph = styled.p `
  margin: 0;
  padding: 0;
  line-height: 1.58;
  font-size: ${props => (props.smaller
  ? "15px"
  : "17px")};
  font-weight: 400;
`;

export class FakeContent extends Component {
  render() {
    return (<div
      style={{
      height: 500,
      width: "100%",
      ...this.props.style
    }}/>);
  }
}
export class Wordmark extends Component {
  render() {
    return (<img
      src={ModilectWordmark}
      alt={"Modilect"}
      style={{
      height: "100%",
      ...this.props.style
    }}/>);
  }
}
export class WordmarkWhite extends Component {
  render() {
    return (<img
      src={ModilectWordmarkW}
      alt={"Modilect"}
      style={{
      height: "100%",
      ...this.props.style
    }}/>);
  }
}
export class LongArrowWhite extends Component {
  render() {
    return (<img
      src={longArrowImg}
      alt={"Intresseanmälan"}
      style={{
      height: "100%",
      ...this.props.style
    }}/>);
  }
}

const MoveOnHover = styled.div `
  transform-origin: center;
  display: inline-block;
  transition: 0.3s ease-in-out;
  opacity: ${props => (props.hide
  ? "0"
  : "1")};
  transform: ${props => (props.hide
  ? "translateX(20px)"
  : "translateX(0px)")};
`;

const ReadMoreText = styled.button `
  cursor: ${props => (props.hide
  ? "inherit"
  : "pointer")};
  width: 100%;
  text-align: inherit;
  display: flex;
  align-items: center;
  font-size: 20px;
  flex-shrink: 0;
  margin-right: 10px;
  transition: 1s ease-in-out;
  opacity: ${props => (props.hide
  ? "0.2"
  : "1")};

  &:hover ${MoveOnHover} {
    transform: ${props => props.hide
  ? "translateX(20px)"
  : "translateX(5px)"};
  }
`;

const ToShow = styled.div `
  position: relative;
  transition: 1s ease-in-out;
  overflow: hidden;

  cursor: ${props => (props.show
  ? "inherit"
  : "pointer")};
  max-height: ${props => (props.show
  ? "2500px"
  : "100px")};
`;

export class Marked extends Component {
  render() {
    return (
      <span
        style={{
        ...this.props.style,
        background: primary
      }}>
        {" "}
        {this.props.children}{" "}
      </span>
    );
  }
}

export class CookiesText extends Component {
  render() {
    return (
      <div>
        <LargeTitle>Cookies</LargeTitle>
        <InfoParagraph>
          En cookie, eller kaka på svenska, är en liten textfil som webbplatsen begär att
          få lagra på besökarens dator och som innehåller en viss mängd information och en
          viss tidsstämpel. Webbläsaren sparar informationen på ett speciellt ställe i din
          dator och returnerar informationen i kakan till webbplatsen man besökt vid varje
          förfrågan av sidor/bilder från webbplatsen.
          <SmallMargin/>
          Permanenta cookies lagras som en fil på din dator under en viss tid, dock längst
          12 månader. Session cookies lagras tillfälligt i din dators minne och försvinner
          när du stänger din webbläsare.
          <SmallMargin/>
          <LargeTitle>Tredjeparts cookies</LargeTitle>
          Vi använder tredjeparts cookies för att samla in statistik i olika analysverktyg
          (såsom Google Analytics & Hotjar) för att kunna göra ditt besök mer värdefullt.
          De cookies som används är temporära och permanenta (Längst 12 månader).
          <LargeTitle>Hantera Cookies</LargeTitle>
          Om du vill dra in användandet av cookies kan du stänga av cookies via din
          webbläsares säkerhetsinställningar. Du kan även ställa in webbläsaren så att du
          får en varning varje gång webbplatsen försöker sätta en cookie på din dator.
          Genom webbläsaren kan också tidigare lagrade cookies raderas. Se webbläsarens
          hjälpsidor för mer information om hur du kan se vilka cookie som finns lagrade i
          din webbläsare, hur man tar bort dem samt gör inställningar för om cookies ska
          accepteras eller inte. Nedan finns länkar om hur man hanterar cookies i vanliga
          webbläsare.
          <SmallMargin/>
          <a href="https://support.apple.com/sv-se/guide/safari/sfri11471/mac">
            Safari
          </a>
          <SmallMargin/>
          <a href="http://www.google.com/support/chrome/bin/answer.py?hl=sv&answer=95647">
            Chrome
          </a>
          <SmallMargin/>
          <a
            href="https://support.mozilla.org/sv/kb/aktivera-och-inaktivera-kakor-webbplatser-installningar">
            Firefox
          </a>
          <SmallMargin/>
        </InfoParagraph>
      </div>
    );
  }
}

const Overlay = styled.div `
  transition: 0.5s;
  opacity: ${props => (props.hide
  ? "0"
  : "1")};
  visibility: ${props => (props.hide
  ? "hidden"
  : "visible")};
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
`;
const Faded = styled.div `
  height: 100px;
  width: 100%;
  position: relative;
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0.4) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 1) 100%
  );
`;
export class ReadMore extends Component {
  state = {
    showMore: false
  };

  setShowMore = () => {
    this.setState({showMore: true});
  };

  render() {
    return (
      <div>
        <SmallMargin/>
        <SmallMargin/>

        <div
          className='ReadMoreBtn'
          style={{
          display: "flex",
          alignItems: "center"
        }}>
          <ReadMoreText
            onClick={this.setShowMore}
            hide={this.state.showMore}
            className='ReadMoreBtn'>
            <div style={{
              flexShrink: "0"
            }}>
              Läs mer
            </div>
            <MoveOnHover hide={this.state.showMore}>
              <Plus
                size={19}
                style={{
                marginLeft: 10,
                verticalAlign: "sub"
              }}/>
            </MoveOnHover>
            <Line
              style={{
              width: this.state.showMore
                ? "50%"
                : "0%",
              transition: "ease 1s 0.5s"
            }}/>
          </ReadMoreText>
        </div>
        <SmallMargin/>
        <SmallMargin/>
        <ToShow show={this.state.showMore} onClick={this.setShowMore} id='ReadMoreBtn'>
          {this.props.children}
          <Overlay hide={this.state.showMore}>
            <Faded/>
            <div
              style={{
              width: "100%",
              height: "100%",
              background: "white"
            }}/>
          </Overlay>
        </ToShow>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Tools/Variables.js